const Icon = () => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_250_292)'>
        <mask id='mask0_250_292' maskUnits='userSpaceOnUse' x='0' y='0' width='30' height='30'>
          <rect width='30' height='30' fill='white' />
        </mask>
        <g mask='url(#mask0_250_292)'>
          <circle opacity='0.15' cx='15' cy='15' r='15' fill='#8B8E9F' />
        </g>
        <g clipPath='url(#clip1_250_292)'>
          <rect
            x='9.92371'
            y='11.415'
            width='1.36759'
            height='12.9921'
            rx='0.683795'
            transform='rotate(-45 9.92371 11.415)'
            fill='black'
          />
          <rect
            x='19.1113'
            y='10.4482'
            width='1.36759'
            height='12.9921'
            rx='0.683795'
            transform='rotate(45 19.1113 10.4482)'
            fill='black'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_250_292'>
          <rect width='30' height='30' fill='white' />
        </clipPath>
        <clipPath id='clip1_250_292'>
          <rect width='12.9921' height='12.9921' fill='white' transform='translate(5.81445 15.5249) rotate(-45)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Icon;
